import { z } from '@hono/zod-openapi'

export const idZ = z
  .number()
  .openapi({ description: '請求書ID', example: 1001 })
export type id = z.infer<typeof idZ>

export const ownerIdZ = z
  .string()
  .min(1)
  .openapi({ description: '請求先のオーナーID', example: 'owner_123' })
export type ownerId = z.infer<typeof ownerIdZ>

export const billingMonthZ = z
  .string()
  .regex(/^\d{4}-\d{2}$/)
  .openapi({ description: '請求対象月（YYYY-MM）', example: '2024-03' })
export type billingMonth = z.infer<typeof billingMonthZ>

export const stripeInvoiceIdZ = z
  .string()
  .max(255)
  .nullable()
  .openapi({ description: 'Stripe側の請求書ID', example: 'in_1PnXXXXXXX' })
export type stripeInvoiceId = z.infer<typeof stripeInvoiceIdZ>

export const stripeCustomerIdZ = z
  .string()
  .max(255)
  .openapi({ description: 'Stripe側の顧客ID', example: 'cus_PnXXXXXXX' })
export type stripeCustomerId = z.infer<typeof stripeCustomerIdZ>

export const totalAmountZ = z
  .number()
  .int()
  .openapi({ description: '請求金額の合計（円）', example: 12000 })
export type totalAmount = z.infer<typeof totalAmountZ>

// status
export const INVOICE_STATUS_DRAFT = 'draft'
export const INVOICE_STATUS_OPEN = 'open'
export const INVOICE_STATUS_PAID = 'paid'
export const INVOICE_STATUS_VOID = 'void'
export const INVOICE_STATUS_UNCOLLECTIBLE = 'uncollectible'
export const statusZ = z
  .enum([
    INVOICE_STATUS_DRAFT,
    INVOICE_STATUS_OPEN,
    INVOICE_STATUS_PAID,
    INVOICE_STATUS_VOID,
    INVOICE_STATUS_UNCOLLECTIBLE,
  ])
  .openapi({
    description:
      '請求ステータス（draft:下書き / open:未払い / paid:支払済 / void:無効 / uncollectible:回収不能）',
    example: INVOICE_STATUS_DRAFT,
  })
export type status = z.infer<typeof statusZ>

export const dueDateZ = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .openapi({ description: '支払期限（YYYY-MM-DD）', example: '2024-03-31' })
export type dueDate = z.infer<typeof dueDateZ>

export const paidAmountZ = z
  .number()
  .int()
  .nullable()
  .openapi({ description: '支払済金額（円）', example: 0 })
export type paidAmount = z.infer<typeof paidAmountZ>

export const paidAtStringZ = z.string().nullable().openapi({
  description: '支払完了日時（ISO8601）。null は未払い',
  example: '2024-03-31T15:30:00.000Z',
})
export type paidAtString = z.infer<typeof paidAtStringZ>

export const paidAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: '2024-03-31T15:30:00.000Z' })
export type paidAtDate = z.infer<typeof paidAtDateZ>

export const descriptionZ = z
  .string()
  .max(1000)
  .nullable()
  .openapi({ description: '請求書の説明文', example: '3月分の請求書' })
export type description = z.infer<typeof descriptionZ>

export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-03-01T00:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-03-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-03-05T12:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-03-05T12:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>
